import { Component, OnInit, Inject } from "@angular/core";
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from "@angular/material";
import { Utility } from "../../../../common/utility";

import { DialogService } from "../../../../shared/services/dialog.service";
import { BaseService } from "../../../../shared/services/base.service";
import { ValidationService } from '../../../../shared/services/validation.service';
import { AppConstants } from "../../../../shared/constants/constants";
import { AppMessages } from "../../../../shared/constants/messages";

import { DialogComponent } from "../../../../components/dialog/dialog.component";

@Component({
    selector: "select-master-record",
    templateUrl: "select-master-record-popup.component.html"
})
export class SelectMasterRecordComponent implements OnInit {
  id: any;
  public title= "Select Master Record";
  public message = "Please select a master record, the linked patient infomation will retrieve form the master record";
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    public dialogRef: MdDialogRef<SelectMasterRecordComponent>,
    @Inject(MD_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
   }
  close() {
    this.dialogRef.close();
  }
  onChange(optionValue) {
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/result-search-patient/link-patient/select-master-record-popup.component.ts